module.exports = __webpack_public_path__ + "static/media/loginAssest.f3358601.png";